import React from "react";
import PropTypes from "prop-types";
import tickImage from "../../assets/images/tick_icon.png";
import { format_date_reports } from "../../utils";
import { useMediaQuery } from "react-responsive";

const StatusSection = ({ date ,dNAReportPublishedDate}) => {
  if(date===null){
    date=dNAReportPublishedDate;
  }
  const isHideLine = useMediaQuery({ maxWidth: 390 });

  return (
    <small className="text-muted d-flex flex-row">
      <div className="d-flex">
        Date: <b className="text-color-for-mhc me-2">&nbsp;{format_date_reports(date)}</b>{" "}
      </div>
      <div className="d-flex">
        {!isHideLine && <span className="me-2 status-seperator"></span>} Status:{" "}
        <span className="status-ready">
          <b className="text-color-for-mhc">
            &nbsp;Ready <img src={tickImage} alt="Ready" />
          </b>
        </span>
      </div>
    </small>
  );
};

StatusSection.propTypes = {
  date: PropTypes.string.isRequired,
  dNAReportPublishedDate: PropTypes.string,
};

export default StatusSection;
